import LanguageService from "@/services/LanguageService";

export default {
	contents() {
		return text[LanguageService.langId];
	}
}

let chinese =
`# 墨高油墨


*综合性玻璃油墨供应商*

## 墨高概况

<carousel images="overview1.jpg,overview2.jpg" style="height: 65vmin"></carousel>

佛山市高明绿色德化工有限公司始建于2003年，工厂占地面积20000多平方.历经17年务实创新，已发展成为一家专业生产油墨涂料的绿色环保企业，集研发、生产、销售为一体的集团公司.公司主要生产销售:各种基材丝印油墨、玻璃油墨,玻璃钢化釉料,特种电路导电油墨, UV油墨和涂料,打印UV墨水,水性涂料等。为全球客户提供专业、系统、高质的印刷和表面涂层解决方案。

## 资质与荣誉

<carousel images="cert1.jpg,cert2.jpg" style="height: 35vmin; width: 50%; float: left; margin-right: 32px"></carousel>

公司先后通过IS09001:2008国际质量管理认证体系,及IS0 914001:2004环境管理认证. OHSAS18000职业健康安全管理体系认证.  公司以可持续发展为原则，实施清洁生产,通过2020年广东省绿色清洁生产认证。

墨高油墨产品均通过SGS机构环保检测,\t符合欧洲ROHS和REACH质量认证，并在2009年上半年推出无卤素油墨，体现我们对环境和社会的注重。

## 发展与创新

<carousel images="rnd1.jpg,rnd2.jpg,rnd3.jpg,rnd4.jpg,rnd5.jpg" style="height: 35vmin; width: 50%; float: left; margin-right: 32px"></carousel>

公司从2003年成立时就建立了研发中心，到2020年6月止公司拥有77项专利和多项自主知识产权. 并于2009年通过国家高新技术企业认证。 2013年为持续创新和创造,公司与国家科学院联合创办了新型先进的实验室。

公司核心技术和管理团队，均有十年以上的行业从业经验，有着丰富的理论和实践经验。帮助客户完成从基础研究、设计应用、工艺制造、产品测试一条龙服务。

公司购置了各种先进的生产设备及分析检测仪器，如：纳米砂磨机、液压三辊机、气象色谱仪、 RCA膜耗仪、硬度计、盐雾试验机、恒温恒湿机、QUV老化仪、 膜后仪、色差仪等。

公司主要终端客户有：美的电器,格力电器,海尔电器,欧菲光电,格兰仕,万家乐,老板电器,西门子, 松下,SONY、SAMSUNG、中兴、华为、OPPO、小米、通达集团、银通集团,秀强股份,合肥金晋业等国内外知名企业。

<numbers values="2003年,1000+,${(new Date()).getFullYear() - 2003}年" labels="创立年份,行业优质客户,领军玻璃油墨印刷行业" style=""></numbers>
`

let english =
`# MOCO Ink


*Comprehensive Glass Ink Supplier*


## MOCO Overview

<carousel images="overview1.jpg,overview2.jpg" style="height: 65vmin"></carousel>

MOCO ink was founded in 2003. Our factory covers more than 20,000 square meters. We are a professional and environmentally-friendly ink manufacturing enterprise with 17 years of history that focused on innovation and research. MOCO integrates R&D, production, and sales. Our main products include variation-based silk-screen printing ink, tempered-glass ink, tempered-glass glaze, special circuit conductive ink, UV ink, UV print spray ink, and water based printing ink. We provide professional, comprehensive, and high-quality printing solutions for our global customers.

## Quality and Environment

<carousel images="cert1.jpg,cert2.jpg" style="height: 35vmin; width: 50%; float: left; margin-right: 32px"></carousel>

MOCO ink is ISO9001:2008, ISO914001:2004, and OHSAS18000 certified. We hold sustainability at the highest standard, therefore we manufacture using a clean and environmentally-friendly process, as certified by the Guangdong Province in 2020.

All MOCO products pass SGS Environment inspections and comply with ROHS and REACH quality requirements. Our halogen-free ink released in 2009 is but one manifestation of our focus on sustainability and the environment.

## Research and Innovation

<carousel images="rnd1.jpg,rnd2.jpg,rnd3.jpg,rnd4.jpg,rnd5.jpg" style="height: 35vmin; width: 50%; float: left; margin-right: 32px"></carousel>

The MOCO R&D Center was founded in 2003, and as of June 2020 owns 77 patents and numerous independent intellectual property rights. We are certified as a national high-tech enterprise in 2009, and we co-founded a research laboratory with the National Academy of Science in 2013.

All members of core management have more than 10 years of experience in the ink industry and are knowledgeable in both theory and practice. We provide one-stop services that range from product conception and design to manufacturing and testing.

The company owns a variety of advanced production equipment and analytical testing instruments, such as nano sand mills, hydraulic three-rollers, meteorological chromatographs, RCA film consumption meters, durometers, salt spray test machines, constant temperature & humidity machine, QUV aging Meter, film meter, color difference meter, etc.

Our customers include Media, Gree, Haier, Ofilm, Glanz, Macro, Boss, Siemens, Panasonic, Sony, SAMSUNG, ZTE, HUAWEI, OPPO, Xiaomi, TongDa Group, and more.

<numbers values="2003,1000+,${(new Date()).getFullYear() - 2003} Yrs" labels="Established in,Client connections,Led the industry for" style=""></numbers>`

let text = [chinese, english];
